// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__KC27H","paymentContainer":"PaymentPage_paymentContainer__15cza"};